module.exports = __webpack_public_path__ + "static/memory_img5M@2x-0f3df3d130ce2556f63de76ddd945f35.png";